import { render, staticRenderFns } from "./CustomerPasswordSetup.vue?vue&type=template&id=53069a62&scoped=true"
import script from "./CustomerPasswordSetup.vue?vue&type=script&lang=js"
export * from "./CustomerPasswordSetup.vue?vue&type=script&lang=js"
import style0 from "./CustomerPasswordSetup.vue?vue&type=style&index=0&id=53069a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53069a62",
  null
  
)

export default component.exports